<template>
  <div class="case-list">
    <ul>
      <li v-for="item in data" :key="item.createtime" v-if="item.onoff === 0" @click="$router.push({path: '/case/detail/' + item.id})">
        <div class="img">
          <img :src="item.image" alt="">
        </div>
        <div class="content">
          <div class="title">{{item.title}}</div>
          <div class="message">
            <span class="tag" v-if="item.tag && JSON.parse(item.tag)[0]">{{JSON.parse(item.tag)[0]}}</span>
            <span class="time">{{item.showtime | formatDate}}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {formatDate} from "@/common/js/data";

export default {
  name: "CaseList",
  props: {
    data: {
      type: Array,
      default: () => ([])
    }
  },
  filters: {
    formatDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy.MM.dd')
    }
  },
}
</script>

<style lang="scss" scoped>
.case-list {
  background: #FFFFFF;
  margin-top: 40px;
  ul {
    padding-bottom: 40px;
    li {
      text-align: left;
      display: flex;
      border-top: 1px solid #ECECEC;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 24px 0;
      .content {
        width: 437px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-start;
        .title {
          font-size: 30px;
          color: #333333;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .message {
          .tag {
            display: inline-block;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            padding: 4px 18px;
            background: #0090C5;
            border-radius: 6px;
            color: #ffffff;
            font-size: 20px;
            margin-right: 30px;
          }
          .time {
            color: #999999;
            font-size: 24px;
          }
        }
      }
      .img {
        width: 222px;
        height: 125px;
        margin-right: 40px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
